import { ClientEnvironment, FooterNavigation } from '@thehubz/client/core';

export const arvalFooterConfig = (env?: ClientEnvironment): FooterNavigation[] => {
  return [
    {
      navLink: [env?.brandConfig?.navigation?.imprintUrl ?? '/content/imprint'],
      navText: $localize`:footer navigation:Imprint`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.privacyUrl ?? '/content/privacy'],
      navText: $localize`:footer navigation:Privacy`,
    },
  ];
};
